import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineCoreLineArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#44BBB5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M7.997 1.175v13.65M1.7 8.525l6.3 6.3 6.3-6.3"
    />
  </svg>
);
export default SvgStreamlineCoreLineArrowDown;
